<template>
  <div class="xcard">
    <h4 class="text-center"> Plan de pagos del estudiante (Contabilidad)</h4>
    
    <p class="text-right" style="position:relative;top:0px;right:15px;margin-bottom:0"> <router-link :to="routerTo" class="btn btn-sm btn-link"> <span class="glyphicon glyphicon-arrow-left"></span> Volver</router-link> </p>
    <button class="btn btn-link" type="button" @click="xreprogramarPagos()" title="Re programar el plan de pagos" data-toggle="modal" data-target="#planPagos">  <span class="glyphicon glyphicon-print"></span> Reprogramar Plan de Pagos  </button>
    <button class="btn btn-link" type="button" @click="xgenerarContrato()" title="PDF para imprimir">  <span class="glyphicon glyphicon-print"></span> Generar Contrato  </button>
    <button class="btn btn-link" type="button" @click="xpreEliminarPagos()" title="PDF para imprimir">  <span class="glyphicon glyphicon-print"></span> Eliminar Plan Pagos  </button>

    <Alertas ref="xalertar" />
    <PlanPagos :cuotas="cuotas" v-on:regenerar="regenerar"/>

    <div v-if="getInscripcion.matricula.monto > 0" class="row">
      <div class="col-sm-6">
         <p> <b>Matricula:</b> {{getInscripcion.monto_matricula}} Bs. </p>
        <TablaMatricula :getInscripcion="getInscripcion" :listener="listener"/>
      </div>

      <div class="col-sm-6">
        <p> <b>Pagos de Matricula:</b> </p> 
        <TablaMatriculaPagos :getInscripcion="getInscripcion" :listener="listener"/>
      </div>
    </div>
    <div v-else> <b>Matricula:</b> 0 Bs.</div>
    <hr>

    <div class="row">
      <div class="col-sm-12">
        <p> <b>Pagos Parciales de las cuotas:</b> <small>(Cuando la cuota tiene saldo pendiente)</small> </p>
        <TablaCuotasPagos :getInscripcion="getInscripcion" :listener="listener"/>
        <hr>

        <p> <b>Cuotas canceladas total:</b> <small>(Cuando la cuota no tiene saldo pendiente)</small> </p>
        <TablaCuotasCaceladas :getInscripcion="getInscripcion" :listener="listener"/>
        <hr>

        <p> <b>Cuotas por Pagar:</b> </p>
        <TablaCuotasPagar :getInscripcion="getInscripcion" :listener="listener" :isAsesor="isAsesor"/>
      </div>

      
    </div>
   
   <!-- FALTA VALIDAR QUE LA MATRICULA SEA CONTADO O AL CREDITO EN AM.VUE Y HACER LAS OPCIONES DE PDF, CANCELAR CUOTAS Y EVITAR 
   EL RELOAD() AL PAGAR, TIENE QUE SER AUTOMATICO HEHEHEHE SI SE PUEDE
    -->

    
    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
import {generarContrato} from '@/components/generar-contrato.js'
import { parseJsonError,error } from '@/components/Utils.js'
import Alertas from '@/components/AAlertas.vue'
import TablaMatricula from '@/components/ATablaMatricula.vue'
import TablaMatriculaPagos from '@/components/ATablaMtriculaPagos.vue'
import TablaCuotasCaceladas from '@/components/ATablaCuotasCaceladas.vue'
import TablaCuotasPagar from '@/components/ATablaCuotasPagar.vue'
import TablaCuotasPagos from '@/components/ATablaCuotasPagos.vue' 
import PlanPagos from '@/components/AVer-cuotas.vue'
import gql from 'graphql-tag'

export default {
  data(){
    return{
      routerTo: '',
      isAsesor: this.$store.state.CARGO.id == 11 || this.$store.state.CARGO.id == 13,
      pagarMatricula:{ id:-1 },
      listener:{ flag:0 }, // llamado desde los componentes para recargar la vista
      programita:{},
      getInscripcion:{
        matricula:{pagos:[]},
        cuotas_por_pagar:{pagos:[]},
        cuotas_canceladas:{pagos:[]},
      },
      cuotas:[],
    }
  },
  components:{ Alertas,TablaMatricula,TablaMatriculaPagos,TablaCuotasCaceladas,TablaCuotasPagar,TablaCuotasPagos,PlanPagos },
  watch:{
    'listener.flag': function(){ 
      var xins = sessionStorage.xins;
      this.getXInscripcion( xins );
    }
  },
  methods:{
    xgenerarContrato(){
      if( this.getInscripcion.estudiante == null ){
        this.$notify( error( 'Contrato','Seleccione un Estudiante.' ) );
        return;
      }
      var montos = { monto_matricula:this.getInscripcion.monto_matricula,monto_colegiatura:this.getInscripcion.monto_colegiatura };
      generarContrato( this.programita,this.getInscripcion.cuotas_por_pagar,this.getInscripcion.estudiante,montos,this.getInscripcion )
    },
    xpreEliminarPagos(){
      var vue = this;
      var opt = {
        verification: 'eliminar',
        verificationHelp: 'Escriba "[+:verification]" para eliminar el plan de pagos, No debe tener pagos realizados para poder eliminar.',
        okText:"Eliminar Plan de Pagos",
        cancelText:"cancelar",
        backdropClose:false,
        animation: 'bounce',
        loader: true, 
        type:"hard"
      }
      var message = {
        title: 'Confirmar eliminacion',
        body: '<br> <b>NOTA:</b> esta accion es irreversible.'
      };
      this.$dialog.confirm(message,opt)
      .then(function( dialog ) { 
        vue.xeliminarPagos( dialog );
      })
      .catch(function() {});
    },
    xeliminarPagos( dialog ){
      var vue = this;
      var idins = this.getInscripcion.id;
      var idest = this.getInscripcion.estudiante.id;
      var idpro = this.programita.id; 
      // NO DEBE TENER PAGOS REALIZADOS

      var b = window.stringifyObject({ inscripcion_id:idins,programa_id:idpro,estudiante_id:idest });
      window.console.log( b );
      var sql = gql`mutation{ eliminarPlanPagosInscripcion(input:${b}){ok,errors{message}} }`;

      this.$apollo.mutate({
        mutation: sql,
      }).then((data) => {
        var res = data.data.eliminarPlanPagosInscripcion;
        if( res.ok ){
          dialog.close();
          this.$router.push({name:'programains'});
        }else{
          var errores = JSON.stringify(data.data.eliminarPlanPagosInscripcion.errors);
          var obj = JSON.parse( errores );
          var vals = '';
          obj.forEach(function(k){ delete k.__typename; vals += Object.values(k)+" \n\t"; });
          vals = vals+' Revise que no tenga pagos realizados.';
          window.alert( vals )
          dialog.close();
        }
      }).catch((error) => {
        vue.msg = error;
        window.console.error(error)
        vue.$notify( parseJsonError( error,'getInscripcion' ) )
      })

      
    },
    regenerar( cole,cuotas ){
      // window.console.log( "HHEE",cole,cuotas );
      this.xreprogramarPagos( cole,cuotas );
    },
    xreprogramarPagos( mcole,mcuo ){
      if(!mcole) mcole = this.getInscripcion.monto_colegiatura;
      if(!mcuo) mcuo = this.getInscripcion.cuotas;
      window.localStorage.setItem('idinscripcion',this.getInscripcion.id)
      
      if( mcole != null && mcuo != null ){
        var mensualidad = Math.trunc( Math.ceil(mcole / mcuo) );
        if( !isNaN(mensualidad) && isFinite(mensualidad) ){
          var cole = parseInt(mcole);
          var cuos = [];
          var nro = 1;
          var fecha = new Date();
          var srtf = "";
          while( cole-mensualidad > 0 ){
            var ani = fecha.getFullYear();
            var mes = fecha.getMonth()+1;
            var dia = fecha.getDate();
            if( mes < 10 ) mes = '0'+mes;
            if( dia < 10 ) dia = '0'+dia;
            cole = cole - mensualidad;
            srtf = ani+"-"+mes+"-"+dia;
            fecha.setMonth( mes );
            fecha.setDate( 15 );
            cuos.push( {monto:mensualidad,nro_cuota:nro,fecha:srtf} );
            nro += 1;
          }
          if(cole>0){
            ani = fecha.getFullYear();
            mes = fecha.getMonth()+1;
            dia = fecha.getDate();
            if( mes < 10 ) mes = '0'+mes;
            if( dia < 10 ) dia = '0'+dia;
            srtf = ani+"-"+mes+"-"+dia;
            fecha.setMonth( mes );
            fecha.setDate( 15 );
            cuos.push( {monto:cole,nro_cuota:nro,fecha:srtf} );
          }
          this.cuotas = cuos;
          window.sessionStorage.setItem( "xcuotas",JSON.stringify(this.cuotas) );
          this.preinscribir = false;
        }
      }

      // window.console.log( "--->",this.getInscripcion,this.cuotas )
    },
    getXInscripcion( id ){
      this.$refs.xalertar.cargando();
        var vue = this;
        var sql = gql`query{
          getInscripcion(id:${id}){
            id 
            estudiante{ id,num_doc,nombres,pri_apellido,seg_apellido,telefono1,domicilio,departamento{extension}}
            asesor{nombres,pri_apellido,seg_apellido}
            monto_matricula,monto_colegiatura,monto_certificacion,cuotas
            matricula{id,monto,saldo,puede_pagar,cancelado,pagos{id,monto,saldo,fecha_pago,nro_recibo}}
            cuotas_por_pagar{id,monto,saldo,fecha,puede_pagar,cancelado,nro_cuota,pagos{id,monto,saldo,fecha_pago,nro_recibo,cuota{ nro_cuota}}}
            cuotas_canceladas{id,monto,saldo,fecha,puede_pagar,cancelado,nro_cuota,pagos{id,monto,saldo,fecha_pago,nro_recibo,cuota{ nro_cuota}}}
          }
        }`;
        vue.msg = '';
        // window.console.log( sql );

        this.$apollo.query({
          query: sql,
        }).then((data) => {
            this.getInscripcion = data.data.getInscripcion;
            if( !this.getInscripcion.cuotas ) this.getInscripcion.cuotas = 1;
            this.getInscripcion.flag = 0;
            this.$refs.xalertar.reset();
            //window.console.log( "getXInscripcion:::",this.getInscripcion )
        }).catch((error) => {
          this.msg = error;
          window.console.error(error)
          this.$notify( parseJsonError( error,'getInscripcion' ) )
        })
    }
  },
  mounted(){
    var xp = window.sessionStorage.xprograma;
    if( xp ) {
      var p = JSON.parse( xp );
      this.programita = p;
    }

    var xins = sessionStorage.xins;
    this.routerTo = sessionStorage.routerTo;
    this.getXInscripcion( xins );
    // window.console.log( "INSCRIPCION",xins );
  }
}
</script>